export default function ModuleHero() {
  return (
    <div className="relative min-h-[50vh] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/a645ca12800bb257846da260c4924dc6.jpg"
          alt="Fisiología del Ejercicio"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-[1400px] mx-auto px-6 py-20 text-center w-full">
        <div className="inline-flex items-center gap-2 bg-[#39FF14]/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
          <span className="w-2 h-2 bg-[#39FF14] rounded-full"></span>
          <span className="text-[#39FF14] font-medium text-sm">MÓDULO 2</span>
        </div>
        
        <h1 className="text-5xl md:text-6xl font-bold text-white mb-6 leading-tight">
          Fisiología del Ejercicio<br />y Adaptaciones
        </h1>
        
        <p className="text-xl text-gray-200 max-w-3xl mx-auto leading-relaxed mb-8">
          Comprende cómo tu cuerpo genera energía, recluta fibras musculares, se fatiga y se adapta al entrenamiento. La base científica para diseñar programas efectivos.
        </p>

        <div className="flex flex-wrap items-center justify-center gap-6 text-white">
          <div className="flex items-center gap-2">
            <i className="ri-time-line text-[#39FF14] text-xl"></i>
            <span className="text-sm">5 Lecciones</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-book-open-line text-[#39FF14] text-xl"></i>
            <span className="text-sm">Contenido Aplicado</span>
          </div>
          <div className="flex items-center gap-2">
            <i className="ri-flask-line text-[#39FF14] text-xl"></i>
            <span className="text-sm">Ejemplos Prácticos</span>
          </div>
        </div>
      </div>
    </div>
  );
}